import React, { useEffect, useState } from "react";
import "./About.css";
import stick1 from "../Assets/stick_1.webp";
import stick2 from "../Assets/stick_2.webp";
import stick3 from "../Assets/stick_3.webp";
import stick4 from "../Assets/certified.jpg";
import stick5 from "../Assets/business.jpg";
import stick6 from "../Assets/global.jpg";
import stick7 from "../Assets/comfident.jpg";

const About = () => {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-us-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <span>BOLDLY</span>
            <span className="space"></span>
            <span>ENGLISH</span>
            {/* <span>L</span>
            <span>D</span>
            <span>L</span>
            <span>Y</span>
            <span className="space"></span>
            <span>E</span>
            <span>N</span>
            <span>G</span>
            <span>L</span>
            <span>I</span>
            <span>S</span>
            <span>H</span> */}
          </h1>
          <div className="hero-tagline">
            <div className="tagline-words">
              <span>BREAK.</span>
              <span>BUILD.</span>
              <span>EMPOWER.</span>
            </div>
          </div>
          <p className="hero-description">
            This is not just an English learning course, it's a life-changing
            platform.
          </p>
        </div>
      </section>

      {/* Our Mission Section */}
      <section
        id="mission-section"
        className={`mission-section animate-on-scroll ${
          isVisible["mission-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>Our Mission</h2>
          <div className="mission-container">
            <div className="mission-image"></div>
            <div className="mission-text">
              <p>
                At BoldlyEnglish, we believe that{" "}
                <span className="highlight">language is power</span>. Our
                mission is to empower students to break through communication
                barriers, build unshakeable confidence, and express themselves
                with the fluency and naturalness of native speakers.
              </p>
              <p>
                We don't just teach English; we transform lives by giving voice
                to brilliant minds that have been silenced by hesitation and
                self-doubt.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Challenge Section */}

      <section
        id="challenge-section"
        className={`challenge-section animate-on-scroll ${
          isVisible["challenge-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>The Challenge We Address</h2>
          <div className="challenge-cards">
            <div className="challenge-card">
              <img src={stick1} alt="Locked Potential" className="card-image" />
              <h3>Locked Potential</h3>
              <p>Brilliant minds held back by poor communication skills</p>
            </div>
            <div className="challenge-card">
              <img src={stick2} alt="Silent Knowledge" className="card-image" />
              <h3>Silent Knowledge</h3>
              <p>Understanding English but hesitating to speak</p>
            </div>
            <div className="challenge-card">
              <img
                src={stick3}
                alt="Barrier to Success"
                className="card-image"
              />
              <h3>Barrier to Success</h3>
              <p>Limited opportunities due to communication gaps</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section
        id="approach-section"
        className={`approach-section animate-on-scroll ${
          isVisible["approach-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>Our Unique Approach</h2>
          <div className="approach-pillars">
            <div className="pillar">
              <h3>BREAK</h3>
              <div className="pillar-content">
                <div className="pillar-icon break-icon"></div>
                <p>Break the shyness barrier that's been holding you back</p>
              </div>
            </div>
            <div className="pillar">
              <h3>BUILD</h3>
              <div className="pillar-content">
                <div className="pillar-icon build-icon"></div>
                <p>Build fluency and confidence through structured practice</p>
              </div>
            </div>
            <div className="pillar">
              <h3>EMPOWER</h3>
              <div className="pillar-content">
                <div className="pillar-icon empower-icon"></div>
                <p>Empower students to speak like native English users</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mindset Shift Section */}
      <section
        id="mindset-section"
        className={`mindset-section animate-on-scroll ${
          isVisible["mindset-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>More Than A Course: A Mindset Shift</h2>
          <div className="mindset-content">
            <div className="mindset-text">
              <p>
                At BoldlyEnglish, we're not just teaching language – we're
                transforming how you see yourself as a communicator. Our
                holistic approach addresses not just vocabulary and grammar, but
                the psychological barriers that prevent fluent expression.
              </p>
              <div className="mindset-quote">
                <p>Speak Bold. Think Bold. Be Bold.</p>
              </div>
              <p>
                This philosophy guides everything we do, creating not just
                English speakers, but confident global communicators ready to
                share their ideas with the world.
              </p>
            </div>
            <div className="mindset-visual">
              <div className="circle-animation">
                <div className="circle c1">
                  <span>Confidence</span>
                </div>
                <div className="circle c2">
                  <span>Fluency</span>
                </div>
                <div className="circle c3">
                  <span>Opportunity</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process Section */}
      <section
        id="process-section"
        className={`process-section animate-on-scroll ${
          isVisible["process-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>Our Proven Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Initial Assessment</h3>
              <p>
                We identify your current level and tailor our approach to your
                specific needs
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Daily Practice</h3>
              <p>
                Consistent, judgment-free speaking environment to build your
                confidence
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Confidence Building</h3>
              <p>
                Structured exercises designed to eliminate hesitation and fear
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Real-Life Application</h3>
              <p>Interview prep, group discussions, and practical scenarios</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Programs Section */}
      <section
        id="programs-section"
        className={`programs-section animate-on-scroll ${
          isVisible["programs-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>Our Transformative Programs</h2>
          <div className="programs-container">
            <div className="program-card">
              <div className="program-level">BEGINNER</div>
              <h3>
                Voice Finder <br />
              </h3>
              <p className="program-description">
                Find your voice and build fundamental communication skills
              </p>
              <ul className="program-features">
                <li>Introduction to English and basic communication</li>
                <li>Daily practice sessions with expert trainers</li>
                <li>Real-life role play scenarios</li>
                <li>Building foundational fluency and vocabulary</li>
              </ul>
              <div className="program-duration">30 Days to Confidence</div>
            </div>

            <div className="program-card">
              <div className="program-level">INTERMEDIATE</div>
              <h3>Confidence Builder</h3>
              <p className="program-description">
                Express yourself clearly in professional and social settings
              </p>
              <ul className="program-features">
                <li>Mock interviews and presentations</li>
                <li>Speaking with impact in workplace scenarios</li>
                <li>Expressing opinions and making suggestions</li>
                <li>Group discussions on everyday topics</li>
              </ul>
              <div className="program-duration">30 Days to Fluency</div>
            </div>

            <div className="program-card">
              <div className="program-level">ADVANCED</div>
              <h3>
                Impact Speaker <br />
              </h3>
              <p className="program-description">
                Master complex communication for leadership roles
              </p>
              <ul className="program-features">
                <li>Advanced sentence structures and intonation</li>
                <li>Critical thinking and debating skills</li>
                <li>Confident professional presentations</li>
                <li>Accent neutralization exercises</li>
                <br />
              </ul>
              <div className="program-duration">30 Days to Mastery</div>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Trainers Section */}
      <section
        id="trainers-section"
        className={`trainers-section animate-on-scroll ${
          isVisible["trainers-section"] ? "visible" : ""
        }`}
      >
        <div className="section-content">
          <h2>Our Expert Trainers</h2>
          <p className="trainers-intro">
            Our biggest strength lies in our EXPERT TRAINERS who combine
            technical knowledge with empathetic teaching approaches.
          </p>
          <div className="trainers-grid">
            <div className="trainer-feature">
              <img
                src={stick4}
                alt="Certified IELTS and TOEFL Trainers"
                className="trainer-image"
                loading="lazy"
                decoding="async"
              />
              <p>Certified IELTS and TOEFL Trainers</p>
            </div>
            <div className="trainer-feature">
              <img
                src={stick5}
                alt="Business Communication Credentials"
                className="trainer-image"
                loading="lazy"
                decoding="async"
              />
              <p>Advanced credentials in Business Communication</p>
            </div>
            <div className="trainer-feature">
              <img
                src={stick6}
                alt="Global Experience"
                className="trainer-image"
                loading="lazy"
                decoding="async"
              />
              <p>Global experience and international exposure</p>
            </div>
            <div className="trainer-feature">
              <img
                src={stick7}
                alt="Empathetic Teaching Approach"
                className="trainer-image"
                loading="lazy"
                decoding="async"
              />
              <p>Empathetic teaching approach focused on student success</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
